var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215.94,
    height: 193.15,
    viewBox: "0 0 215.94 193.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6979",
    "data-name": "Rectangle 6979",
    width: 215.94,
    height: 193.15,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60926",
    "data-name": "Group 60926",
    transform: "translate(-212.03 -356.902)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6980",
    "data-name": "Rectangle 6980",
    width: 207,
    height: 184,
    transform: "translate(217 361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60925",
    "data-name": "Group 60925",
    transform: "translate(212.03 356.902)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40971",
    "data-name": "Path 40971",
    d: "M66.909,88.567A14.282,14.282,0,0,1,54.4,102.887c-4.652.593-8.895-.273-12.541-3.259a13.652,13.652,0,0,1-.222-21.1c7.5-6.486,19.5-4.264,23.926,4.438a11.526,11.526,0,0,1,1.347,5.6m-9.409.326a5.65,5.65,0,1,0-5.636,5.547A5.536,5.536,0,0,0,57.5,88.893",
    transform: "translate(11.649 23.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40972",
    "data-name": "Path 40972",
    d: "M53.506,106.551c6.168.033,11.8,3.5,13.993,8.656a13.78,13.78,0,0,1-5.837,17.485,16.2,16.2,0,0,1-18.252-1.415,13.85,13.85,0,0,1,4.354-23.645,21,21,0,0,1,3.059-.864,22.934,22.934,0,0,1,2.684-.216m5.686,14.107A5.649,5.649,0,1,0,53.55,126.2a5.534,5.534,0,0,0,5.642-5.539",
    transform: "translate(12.204 33.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40973",
    "data-name": "Path 40973",
    d: "M110.159,92.367a3.208,3.208,0,0,0,2.243,2.472,8.054,8.054,0,0,0,7.511-.673c.327-.215.944-.419,1.187-.261,2.006,1.308,3.955,2.7,6.014,4.133a10.639,10.639,0,0,1-5.466,3.995c-5.865,1.881-11.518,1.577-16.431-2.476-4.234-3.492-5.475-8.26-4.476-13.48A12.976,12.976,0,0,1,110.991,75.3c7.141-1.794,13.511,1.358,16.213,6.9a15.413,15.413,0,0,1,1.414,8.688c-.121,1.084-.536,1.435-1.618,1.424-5.07-.046-10.14-.021-15.21-.016-.48,0-.959.045-1.632.078m9.625-6.336a4.746,4.746,0,0,0-5.187-3.7c-2.454.2-4.569,1.923-4.592,3.7Z",
    transform: "translate(31.95 23.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40974",
    "data-name": "Path 40974",
    d: "M93.641,124.122a3.123,3.123,0,0,0,2.213,2.47,8.056,8.056,0,0,0,7.511-.654c.332-.216.947-.437,1.187-.281,2.009,1.307,3.961,2.7,6.027,4.14a10.6,10.6,0,0,1-5.444,3.991c-5.96,1.908-11.684,1.584-16.618-2.618-4.133-3.519-5.307-8.263-4.284-13.433A12.964,12.964,0,0,1,94.44,107.064c7.177-1.813,13.535,1.381,16.226,6.873a14.906,14.906,0,0,1,1.448,8.318c-.193,1.79-.222,1.79-1.994,1.79q-7.421,0-14.843,0c-.481,0-.961.041-1.637.073m9.525-6.329c.012-1.976-2.228-3.676-4.64-3.73s-4.773,1.616-5.121,3.73Z",
    transform: "translate(26.678 33.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40975",
    "data-name": "Path 40975",
    d: "M18.577,86.347c0-5.508.025-11.017-.021-16.525-.009-1.117.331-1.485,1.465-1.478,6.783.042,13.568.018,20.352.024,1.394,0,1.572.179,1.27,1.463-.55,2.338-1.179,4.657-1.733,6.994-.186.79-.611,1.017-1.389,1.006-2.82-.037-5.641.017-8.459-.03-1.034-.017-1.5.289-1.446,1.39.07,1.343.051,2.692.007,4.037-.032.959.376,1.308,1.311,1.3,2.288-.032,4.578.026,6.865-.024,1.047-.022,1.465.32,1.427,1.409-.069,2-.071,4,0,6,.038,1.063-.4,1.329-1.366,1.311-2.288-.046-4.578.018-6.865-.029-1.009-.021-1.387.36-1.376,1.36.034,2.855-.017,5.712.025,8.568.013.936-.269,1.306-1.256,1.285-2.532-.058-5.069-.063-7.6,0-1.009.025-1.234-.36-1.229-1.285.032-5.589.016-11.18.016-16.77",
    transform: "translate(5.845 21.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40976",
    "data-name": "Path 40976",
    d: "M18.421,118.174c0-5.509.029-11.018-.024-16.527-.011-1.169.339-1.581,1.527-1.543,2.328.077,4.66.017,6.989.025,1.507,0,1.56.055,1.56,1.618q.006,11.874,0,23.748c0,1.783.005,1.786,1.749,1.787,3.842,0,7.685.029,11.526-.02,1.018-.013,1.356.309,1.326,1.324-.063,2.162-.042,4.326-.008,6.488.013.781-.24,1.082-1.052,1.079q-11.281-.034-22.561,0c-.95,0-1.047-.454-1.045-1.211.017-5.591.009-11.182.009-16.771",
    transform: "translate(5.794 31.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40977",
    "data-name": "Path 40977",
    d: "M85.915,80.41c-2.212,1.315-4.081,2.468-6,3.519-.235.128-.876-.191-1.147-.475A6.041,6.041,0,0,0,73.653,81.3c-.6.062-1.149.671-1.721,1.03.4.495.7,1.246,1.2,1.438,1.944.727,3.97,1.225,5.936,1.9,2.717.926,5.228,2.214,6.627,4.889A7.955,7.955,0,0,1,81.566,101.6a17.039,17.039,0,0,1-17.245-1.5,11.434,11.434,0,0,1-2.389-2.584,1.215,1.215,0,0,1,.17-1.183c1.857-1.319,3.776-2.548,5.762-3.862.414.5.76.938,1.133,1.353a6.655,6.655,0,0,0,6.943,2.228c.522-.128.918-.774,1.372-1.183-.462-.448-.849-1.133-1.4-1.31-2.328-.744-4.728-1.261-7.055-2.007a9.148,9.148,0,0,1-5.589-4.1c-2.178-3.929-.6-8.752,3.653-11.022,4.5-2.4,12.137-2.358,16.457,1.374.848.732,1.57,1.609,2.535,2.61",
    transform: "translate(19.65 23.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40978",
    "data-name": "Path 40978",
    d: "M95.8,70v2.117c0,1.224.046,2.451-.013,3.671-.05,1.035.4,1.366,1.38,1.343,1.757-.041,3.515.02,5.27-.02.958-.021,1.316.38,1.3,1.312q-.051,2.691,0,5.385c.016.9-.371,1.236-1.252,1.221-1.8-.032-3.6.018-5.393-.016-.947-.019-1.323.369-1.3,1.311.04,1.55.063,3.1,0,4.65-.193,4.756,3.38,5.274,6.526,4.442,1.381-.364,1.4-.433,1.409,1.039.007,1.875-.013,3.752.007,5.629a1.394,1.394,0,0,1-.967,1.49c-7.171,3.011-15.882-.346-16.419-9.657-.144-2.522-.083-5.058-.034-7.586.02-1.033-.361-1.382-1.355-1.322-.958.057-1.92.012-2.882.012-.069-.14-.137-.278-.2-.418q6.74-7.373,13.484-14.747L95.8,70",
    transform: "translate(26.035 22.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40979",
    "data-name": "Path 40979",
    d: "M76.508,118.272c.386-.694.648-1.126.876-1.577,1.453-2.873,2.874-5.762,4.376-8.608a1.837,1.837,0,0,1,1.252-.907c2.655-.082,5.314-.04,7.971-.025a3.12,3.12,0,0,1,.724.236c-.352.674-.648,1.275-.972,1.86Q84.023,121.33,77.293,133.4a6.991,6.991,0,0,1-.9,1.064,9.172,9.172,0,0,1-.86-1.112q-6.865-12.274-13.7-24.56c-.867-1.554-.807-1.657.977-1.659,2.126,0,4.255.053,6.378-.024a2.06,2.06,0,0,1,2.184,1.344c1.335,2.749,2.754,5.456,4.153,8.173.249.484.561.935.992,1.649",
    transform: "translate(19.469 34.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40980",
    "data-name": "Path 40980",
    d: "M134.479,77.2c1.723-.744,3.234-1.4,4.747-2.05a2.309,2.309,0,0,1,.348-.119c1.927-.489,2.205-.278,2.205,1.672,0,2.121-.03,4.242.014,6.362.02.888-.231,1.3-1.183,1.166a7.521,7.521,0,0,0-1.588.008c-2.993.235-4.521,1.829-4.546,4.823-.03,3.915-.047,7.83.014,11.745.019,1.14-.253,1.587-1.48,1.537-2.325-.095-4.656-.053-6.984-.016-.841.015-1.158-.28-1.155-1.13q.028-12.171,0-24.344c0-1.029.422-1.351,1.4-1.329,2.04.046,4.083.021,6.126.011,1.162-.007,2.5-.276,2.083,1.664",
    transform: "translate(39.748 23.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40981",
    "data-name": "Path 40981",
    d: "M10.959,100.234H.01V.023h215.8V99.767H204.868v-88.8H10.959Z",
    transform: "translate(-0.069 0.007)",
    fill: "#ef3d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40982",
    "data-name": "Path 40982",
    d: "M215.815,168.315H.011V76.045H10.959v81.322h193.91V75.578h10.947Z",
    transform: "translate(-0.069 24.102)",
    fill: "#fdb71b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6977",
    "data-name": "Rectangle 6977",
    width: 10.948,
    height: 90.296,
    transform: "translate(-0.073 51.076)",
    fill: "#1797d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6978",
    "data-name": "Rectangle 6978",
    width: 10.948,
    height: 90.296,
    transform: "translate(204.759 51.076)",
    fill: "#1797d4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlLogo);
export default __webpack_public_path__ + "static/media/fl_logo.8fd3bd23c1fd3ec1b4e63791142ca483.svg";
export { ForwardRef as ReactComponent };